<template>
    <div
        class="mt-2"
    >
        <v-flex
            lg4
            md6
            sm8
            v-cloak
            v-if="personId"
            xs12
        >
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-address-card</v-icon>
                    Address
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonAddressDialog :person-id="personId" />
            </v-toolbar>
            <v-card>

                <v-simple-table
                    class="table"
                    id="personAddressTable"
                    style="table-layout:fixed;"
                >
                    <tbody style="table-layout: fixed">
                    <tr>
                        <td>
                            <div class="py-3">Address Line One</div>
                        </td>
                                    <td>{{ personAddress.addressLineOne }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Address Line Two</div>
                                    </td>
                                    <td>{{ personAddress.addressLineTwo }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Town</div>
                                    </td>
                                    <td>{{ personAddress.town }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">County</div>
                                    </td>
                                    <td>{{ personAddress.county }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Longitude</div>
                                    </td>
                                    <td>{{ personAddress.longitude }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Latitude</div>
                                    </td>
                                    <td>{{ personAddress.latitude }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Postcode</div>
                                    </td>
                                    <td>{{ personAddress.postCode }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Country</div>
                                    </td>
                                    <td>{{ getPersonnelCountryNameById(personAddress.personnelCountryId) }}</td>
                                </tr>
                                <tr>
                                    <td>

                                        <div class="py-3">Email Address (Personal)</div>
                                    </td>
                                    <td>{{ personAddress.emailAddressPersonal }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="py-3">Comments</div>
                                    </td>
                                    <td>{{ personAddress.comments }}</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card>
                    </v-flex>
                    <v-flex
                        lg4
                        md6
                        sm8
                        v-cloak
                        v-else
                        xs12
                    >
                        Person not retrieved from database
                    </v-flex>
                </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditPersonAddressDialog from "./EditPersonAddressDialog";

    export default {
        name: "PersonAddress",
        components: {
            EditPersonAddressDialog,
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                namespace: "personPersonSummarys",
            };
        },

        computed: {
            ...mapGetters(
            [
                "personAddress",
                "countryList",
                "ecsCompanyList",
                "jobList",
                "teamList",
                "getPersonnelCountryNameById",
            ]
            )
        },

        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
    #personAddressTable > div > table {
        table-layout: fixed !important;
    }
</style>
